import { render, staticRenderFns } from "./comp_CartAutoRemovalsChip.vue?vue&type=template&id=01473d23"
import script from "./comp_CartAutoRemovalsChip.vue?vue&type=script&lang=js"
export * from "./comp_CartAutoRemovalsChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports